<template>
  <div>
    <div class="heatmap">
      <div
        class="heatmap__item"
        :class="day.isDone ? 'heatmap__item--done' : ''"
        v-for="(day, index) in events"
        :key="index"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import habitHelper from '../../../helpers/habitHelper';

const thisMonth = new Date().getMonth();

export default {
  props: {
    activityLogs: Array,
    habit: Object,
  },
  data() {
    return {
      date: new Date(),
      events: [
        new Date(2017, thisMonth, 2),
      ],
      unselectableDates: [
        new Date(2017, thisMonth, 29),
      ],
      bars: false,
      locale: undefined,
    };
  },
  computed: {
    ...mapState({
      habitsWithLogs: (state) => state.habitsDashboard.habitsWithLogs,
    }),
  },
  mounted() {
    this.locale = this.$i18n.locale.replace('_', '-');
    const selectHabit = this.habitsWithLogs.find((e) => e.localId === this.habit.localId);
    const daysToShow = 128;
    const daysInCalendar = this.$getDaysFromNow(daysToShow).reverse();
    // eslint-disable-next-line max-len
    const daysStatus = daysInCalendar.map((e) => ({ date: e, ...habitHelper.isHabitDoneForDay(e, selectHabit) }));
    this.events = daysStatus;
  },
  methods: {
  },
};
</script>
<style scoped lang="scss">
  .heatmap {
    margin: 30px auto;
    width: 95%;
    height: 100px;
    align-content: center;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    &__item {
      margin: 1px;
      width: 14px;
      height: 14px;
      background: #161b22;
      border-radius: 2px;
      &--done {
        background: green;
      }
    }
  }
.wrapper {
  padding-top: 80px;
  background: $background-light-color;
  height: 100%;
  color: white;
  box-shadow: none;
}
::v-deep {
  .dropdown-content {
    box-shadow: none !important;
  }
}
</style>
